import {db} from "../firebase/firebase";
import {collection} from "firebase/firestore";

export const TABLE_USER_FORM_DATA = "user_form_data";
export const COLLECTION_USER_FORM_DATA = collection(db, TABLE_USER_FORM_DATA);
